import React from "react";

interface Props {
  avgPrice: string;
  minPrice: string;
  maxPrice: string;
}

const ZonePriceCard: React.FC<Props> = ({ avgPrice, minPrice, maxPrice }) => (
  <div className="bg-gray-100 rounded-xl p-4 mb-4">
    <p className="text-sm md:text-base text-gray-500">Precio promedio por m²</p>
    <p className="text-3xl md:text-5xl font-bold text-gray-900 tracking-tight !font-grotesk">{avgPrice}</p>
    <p className="text-sm md:text-base text-gray-500">
      Rango típico: {minPrice} - {maxPrice}
    </p>
  </div>
);

export default ZonePriceCard;
